import React from "react";

interface BagIconProps {
  /** Tailwind class for color (default: text-white). Path uses currentColor. */
  className?: string;
  width?: number;
  height?: number;
}

/**
 * Shopping-bag icon used by Owlet's Payment header.
 * Path inherits color via `currentColor`, so it picks up the parent's `text-*`.
 */
export function BagIcon({
  className = "text-white shrink-0",
  width = 17.5,
  height = 20,
}: BagIconProps) {
  return (
    <svg
      aria-hidden="true"
      width={width}
      height={height}
      viewBox="0 0 21 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.1875 7.03125V9.1875H12.9375V7.03125C12.9375 5.44551 11.6482 4.15625 10.0625 4.15625C8.47676 4.15625 7.1875 5.44551 7.1875 7.03125ZM5.03125 11.3438H2.15625V20.6875C2.15625 21.8779 3.12207 22.8438 4.3125 22.8438H15.8125C17.0029 22.8438 17.9688 21.8779 17.9688 20.6875V11.3438H15.0938V13.8594C15.0938 14.4568 14.6131 14.9375 14.0156 14.9375C13.4182 14.9375 12.9375 14.4568 12.9375 13.8594V11.3438H7.1875V13.8594C7.1875 14.4568 6.70684 14.9375 6.10938 14.9375C5.51191 14.9375 5.03125 14.4568 5.03125 13.8594V11.3438ZM5.03125 9.1875V7.03125C5.03125 4.25059 7.28184 2 10.0625 2C12.8432 2 15.0938 4.25059 15.0938 7.03125V9.1875H17.9688C19.1592 9.1875 20.125 10.1533 20.125 11.3438V20.6875C20.125 23.0684 18.1934 25 15.8125 25H4.3125C1.93164 25 0 23.0684 0 20.6875V11.3438C0 10.1533 0.96582 9.1875 2.15625 9.1875H5.03125Z"
        fill="currentColor"
      />
    </svg>
  );
}
